<template>
    <div class="form-group">
        <label for="scanTextarea">{{ $t('input_scan_barcode') }}</label>
        <textarea id="scanTextarea" class="form-control" rows="4" v-model="scannedReference"
            @input="handleScan"></textarea>
    </div>
    <div class="row mb-2 text-end">
        <div class="d-flex gap-1 justify-content-end align-items-center mb-2 flex-wrap">
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" @click="stockTaking">
                <i class="fa-solid fa-boxes-stacked"></i> {{ $t('button_stock_taking') }}
            </button>
            <ChangeStatusModal ref="changeStatusModal" :changeable-shipments-statuses="statuses" :grouped_users="users"
                :selected-shipments="scannedShipments.map(s => s._id)" @status-updated="handleStatusUpdate" />
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" @click="exportShipments">
                <i class="fa-solid fa-file-csv" style="color: #059700"></i> {{ $t('button_download_excel') }}
            </button>
        </div>
    </div>
    <div class="block-rounded block" id="Shipments_Container">
        <div class="block-header block-header-default d-flex justify-content-between align-items-center">
            <div>
                <h3 class="block-title m-0">{{ $t('title_result') }} (<span class="ShipmentsResultCount">{{
                    scannedShipments.length }}</span>)</h3>
            </div>
        </div>
        <div class="block-content block-content-full">
            <div class="progress push" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                <div class="progress-bar" :style="{ width: progress + '%' }">
                    <span class="fs-sm fw-semibold">{{ progress }}%</span>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table-sm table-vcenter js-dataTable-full fs-sm table">
                    <thead>
                        <tr class="text-center">
                            <th>{{ $t('table_reference') }}</th>
                            <th>{{ $t('table_client') }}</th>
                            <th>{{ $t('table_receiver') }}</th>
                            <th>{{ $t('table_mobile_number') }}</th>
                            <th>{{ $t('table_area') }}</th>
                            <th>{{ $t('table_status') }}</th>
                            <th>{{ $t('table_price') }}</th>
                            <th>{{ $t('table_assigned_to') }}</th>
                            <th>{{ $t('table_created_at') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody id="ShipmentsTable">
                        <tr v-if="scannedShipments.length === 0">
                            <td colspan="10" class="table-active text-muted text-center">{{
                                $t('placeholder_empty_table') }}</td>
                        </tr>
                        <tr v-for="shipment in scannedShipments" :key="shipment._id"
                            class="accordion-toggle text-center" :data-bs-target="`#${shipment._id}`">
                            <td><a :href="`/shipments/${shipment._id}`">{{ shipment.reference }}</a></td>
                            <td>
                                <a v-if="shipment.client_data" :href="`/profile/${shipment.client_id}`">{{
                                    shipment.client_data.first_name }}</a>
                                <span v-else style="color: red">No Client Data</span>
                            </td>
                            <td>{{ shipment.receiver_name }}</td>
                            <td class="client_sim_number">
                                <span v-for="(simNumber, index) in shipment.receiver_sim_number" :key="index"
                                    :data-bs-content="getSimPopoverContent(simNumber)" data-bs-toggle="popover"
                                    data-bs-html="true" data-bs-placement="auto">{{ simNumber }}</span>
                            </td>
                            <td>
                                <span v-if="shipment.area_data">{{ shipment.area_data.city_name_ar }}, {{
                                    shipment.area_data.governorate?.governorate_name_ar || '' }}</span>
                                <span v-else class="text-muted">No Area</span>
                            </td>
                            <td class="status-cell">
                                <span v-if="shipment.deleted_at"
                                    class="badge p-2 text-uppercase bg-danger">Deleted</span>
                                <span v-else class="badge p-2 text-uppercase"
                                    :class="`bg-${shipment.status_data.color}`">{{ shipment.status_data.title_ar
                                    }}</span>
                            </td>
                            <td>{{ formatNumberShort(shipment.grand_total) }} {{ defaultCurrencyAcronym }}</td>
                            <td class="text-muted assigned-to-cell">
                                <a v-if="shipment.assigned_to_user" :href="`/profile/view/${shipment.assigned_to}`">{{
                                    shipment.assigned_to_user.first_name }} {{
                                        shipment.assigned_to_user.last_name }}</a>
                                <span v-else class="badge bg-info">Unassigned</span>
                            </td>
                            <td class="text-muted">{{ new Date(shipment.created_at).toLocaleString() }}</td>
                            <td class="text-center">
                                <a href="javascript:void(0)" class="delete-icon" @click="removeShipment(shipment._id)">
                                    <i class="fa-solid fa-times fa-lg text-danger"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- Change Status Modal -->

</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            scannedReference: '',
            scannedShipments: [],
            stockedShipments: [],
            selectedShipments: [],
            statuses: [],
            users: [],
            selectedStatus: '',
            selectedUser: '',
            defaultCurrencyAcronym: 'EGP',
            progress: 0, // Add this line
        };
    },
    mounted() {
        this.fetchStatuses();
        this.fetchUsers();
        const newValue = []; // or any appropriate value for scannedShipments
        this.$refs.changeStatusModal.scannedShipments = newValue;

    },
    methods: {
        handleStatusUpdate(updatedData) {
            console.log('Updated shipments from the scanner:', updatedData);
            console.log('Scanned Shipments:', this.scannedShipments);

            const updatedShipments = updatedData.data.shipments; // Assuming 'data.shipments' contains an array of updated shipments

            if (updatedShipments && updatedShipments.length > 0) {
                updatedShipments.forEach((updatedShipment) => {
                    console.log('Updated Shipment from the details:', updatedShipment);

                    // Find the index of the shipment that needs to be updated based on the matching ID
                    const shipmentIndex = this.scannedShipments.findIndex(shipment => shipment._id === updatedShipment.id);

                    // If the shipment exists in the scanned shipments array, update it
                    if (shipmentIndex !== -1) {
                        // Update status if present in the response
                        if (updatedShipment.status) {
                            console.log('Updated Status:', updatedShipment.status);
                            this.scannedShipments[shipmentIndex].status_id = updatedShipment.status.id; // Update the shipment's status ID
                            this.scannedShipments[shipmentIndex].status_data = { ...updatedShipment.status }; // Optionally, store status data
                        }

                        // Update assigned user if present in the response
                        if (updatedShipment.assigned_user) {
                            console.log('Assigned User:', updatedShipment.assigned_user);
                            this.scannedShipments[shipmentIndex].assigned_to_user = { ...updatedShipment.assigned_user }; // Update the assigned user
                        }

                        // You can also log or handle other properties if required
                    }
                });
            } else {
                console.warn('No updated shipments found in updated data.');
            }

            this.handleProgressBar(); // Update the progress bar
        },
        handleScan() {
            if (this.scannedReference.trim()) {
                this.fetchShipmentByReference(this.scannedReference.trim());
                this.scannedReference = '';
            }
        },
        async fetchShipmentByReference(reference) {
            try {
                const response = await axios.post(`/shipments/ref-scan`, {
                    shipment_reference: reference
                });

                if (response.data.success) {
                    this.addShipmentRow(response.data.shipment);
                } else {
                    this.showNotification('danger', 'Shipment not found!');
                }
            } catch (error) {
                console.error('Error fetching shipment:', error);
                this.showNotification('danger', 'An error occurred while fetching the shipment.');
            }
        },
        addShipmentRow(shipment) {
            if (this.scannedShipments.some(s => s._id === shipment._id)) {
                this.showNotification('danger', 'The Shipment already added');
                return;
            }
            this.scannedShipments.push(shipment);
            console.log(this.scannedShipments);
        },
        removeShipment(shipmentId) {
            this.scannedShipments = this.scannedShipments.filter(s => s._id !== shipmentId);
        },
        handleProgressBar() {
            let totalStocked = this.stockedShipments.length;
            let completed = 0;

            // Count the number of scanned shipments that are in the stocked shipments and have a status of "Delivered"
            this.scannedShipments.forEach(shipment => {
                if (this.stockedShipments.some(stockedShipment => stockedShipment._id === shipment._id)) {
                    completed++;
                }
            });
            console.log('Scanned:', completed, 'Total:', totalStocked);

            // Calculate the progress percentage
            this.progress = totalStocked > 0 ? Math.round((completed / totalStocked) * 100) : 0;
        },
        openChangeStatusModal() {
            if (this.scannedShipments.length === 0) {
                this.showNotification('warning', 'No shipments are added to the table.');
                return;
            }
            $('#changeStatusModal').modal('show');
        },
        async confirmAssign() {
            if (!this.selectedStatus || !this.selectedUser) {
                this.showNotification('danger', 'Please select both a status and a user.');
                return;
            }

            const selectedShipments = this.scannedShipments.map(s => s._id);

        },
        async exportShipments() {
            if (this.scannedShipments.length === 0) {
                this.showNotification('warning', 'No shipments are added to the table.');
                return;
            }

            const selectedShipments = this.scannedShipments.map(s => s._id);

            try {
                const response = await axios.post('/partner/shipments/export', {
                    shipmentsIds: selectedShipments,
                }, {
                    responseType: 'blob',
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'shipments.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error exporting shipments:', error);
                this.showNotification('danger', 'An error occurred while exporting shipments.');
            }
        },
        async stockTaking() {
            if (this.scannedShipments.length === 0) {
                this.showNotification('warning', 'No shipments are added to the table.');
                this.handleProgressBar(); // Update the progress bar
                return;
            } else {
                try {
                    const response = await axios.get('get-stocked-shipments');
                    if (response.data.success) {
                        this.stockedShipments = response.data.shipments; // Store shipments in the array
                        this.handleProgressBar(); // Update the progress bar
                        console.log('Stocked shipments:', this.stockedShipments);
                    } else {
                        console.error('Failed to load shipments');
                    }
                } catch (error) {
                    console.error('Error fetching shipment:', error);
                    this.showNotification('danger', 'An error occurred while fetching the stock.');
                }
            }
        },
        async fetchStatuses() {
            const response = await axios.get('/shipments/get-status');
            this.statuses = response.data;
        },
        async fetchUsers() {
            const response = await axios.get('/partner-users/get-auth-partner-users-grouped');
            this.users = response.data;
        },
        showNotification(type, message) {
            // Implement your notification logic here (e.g., using a library like Toastr)
            console.log(`${type}: ${message}`);
        },
        getSimPopoverContent(simNumber) {
            return `
            <div class="text-center">
            <a href="https://wa.me/${simNumber}" target="_blank" class="btn btn-success my-1" style="width: 80px;">
                <i class="fa-brands fa-whatsapp"></i>
            </a>
            <button class="btn btn-secondary my-1" style="width: 80px;" onclick="copyNumber('${simNumber}')">
                <i class="fa-solid fa-copy"></i>
            </button>
            <a href="tel:+${simNumber}" class="btn btn-primary my-1" style="width: 80px;">
                <i class="fa-solid fa-phone"></i>
            </a>
            </div>
        `;
        },
        formatNumberShort(number) {
            // Implement your number formatting logic here
            return number.toLocaleString();
        },
        hasPermission(permission) {
            // Implement your permission check logic here
            return this.$store.state.user.permissions.includes(permission);
        },
    },
};
</script>

<style scoped>
.progress-bar {
    background-color: var(--progress-color, #fdb13e);
    /* Default color */
    color: #000000;
    /* Black text */
}
</style>